module.exports = __webpack_public_path__ + "static/img/Tino.347ee6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tino.jpg
// module id = d8gf
// module chunks = 0